const state = {
    object: {
        source: {
            type: 'application/x-mpegURL',
            src: '',
            withCredentials: false
        },
        poster: 'http://anysta.kartina.tv/assets/img/logo/comigo/1/2.7.png',
        live: true,
        autoplay: true,
        language: 'ru',
        volume: .05,
        controls: false,
        quality: -1
    },
};

const actions = {
    setVideoPoster({commit, dispatch}, poster) {
        commit('SET_VIDEO_POSTER', poster);
    },
    setVideoSource({commit, dispatch}, src) {
        commit('SET_VIDEO_SOURCE', src);
    },
    setVideoAutoplay({commit, dispatch}, autoplay) {
        commit('SET_VIDEO_AUTOPLAY', autoplay);
    }
};

const mutations = {
    SET_VIDEO_POSTER(state, poster) {
        state.object.poster = poster;
    },
    SET_VIDEO_SOURCE(state, src) {
        state.object.source.src = src;
    },
    SET_VIDEO_AUTOPLAY(state, autoplay) {
        state.object.autoplay = autoplay;
    }
};

export default {
    state,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/video-options.js